module.exports = __webpack_public_path__ + "img/map-marker-icon.a3abc02b.svg";